module.exports = __webpack_public_path__ + "c52d091964bd05b83996370036c6e832.svg";